export const isCurrentFeeTypeStandard = (feeType) => feeType === 'standard';
export const isCurrentFeeTypeMonthly = (feeType) => feeType === 'fixedMonthly';
